import { action, observable, runInAction } from 'mobx';
import { BaseEditViewStore } from 'core/stores';
import { FacilityOrderTemplateNewFlowCreateViewStore } from "application/facility-order-new-flow/stores";
import { FacilityOrderTemplateUSIntakeNewFlowCreateForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderTemplateService} from "application/facility-order/services";
import { LookupService } from "common/services";
import _ from 'lodash';

class CreateFacilityOrderTemplateUSIntakeNewFlowModalStore extends BaseEditViewStore {
    @observable accessor facilityOrderTemplateItems = [];
    @observable accessor facilityOrderTemplateTrachItems = [];
    @observable accessor disabled = false;

    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'create-facility-order-template-us-intake-new-flow-modal',
            Form: FacilityOrderTemplateUSIntakeNewFlowCreateForm,
            actions: () => {
                return {
                    create: async (items, resource, facilityOrderId, patientId) => {
                        let facilityOrderTemplateItems = items.filter(x => x.product);
                        facilityOrderTemplateItems.forEach(i => delete i.id);
                        resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id } });
                        let request = {
                            ...resource,
                            facilityOrderId: facilityOrderId,
                            patientId: patientId,
                            facilityOrderTemplateItems: facilityOrderTemplateItems,
                            newFlowInsuranceStatusId: this.newFlowInsuranceStatusId,
                            isReviewed: this.isReviewed,
                            isClinicalReviewed: this.isClinicalReviewed
                        }

                        const response = await facilityOrderTemplateService.createTemplateAndItemsNewFlow(request);
                        return response.data;
                    }
                }
            },
            FormClass: FacilityOrderTemplateUSIntakeNewFlowCreateForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.patientId = this.modalParams.data.patientId;
        this.patient = this.modalParams.data.patient;
        this.isReviewed = this.modalParams.data.isReviewed;
        this.isClinicalReviewed = this.modalParams.data.isClinicalReviewed;
        this.newFlowInsuranceStatusId = this.modalParams.data.newFlowInsuranceStatusId;
        this.fetchPatientTemplates = this.modalParams.data.fetchPatientTemplates;
        this.rootStore.viewStore.setNavigationOptions({
            title:""
        });

        this.facilityOrderTemplateNewFlowCreateViewStore = new FacilityOrderTemplateNewFlowCreateViewStore(this.rootStore, { form:this.form, facilityOrderTemplateItems:this.facilityOrderTemplateItems, facilityOrderTemplateTrachItems:this.facilityOrderTemplateTrachItems, facilityOrderId:this.modalParams.data.facilityOrderId, patientKey: this.modalParams.data.patientKey, facilityOrder: this.modalParams.data.facilityOrder});

        this.fetch([
			this.initialize()
		]);
    }

    @action
    async initialize() {
		await this.getLookups();
        this.form.clear();
	}

	@action.bound
	async getLookups() {
        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        const response = await lookupService.getLookups("SubCategory");
        runInAction(() => {
            this.subCategories = response.subCategory;
        })
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;
        this.disabled = true;
        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            if (this.facilityOrderTemplateTrachItems.some(i => i.product)) {
                const respiratorySubCategory = this.subCategories.find(x => x.abrv == 'Respiratory---trachs-supply');
                var response = await this.actions.create(this.facilityOrderTemplateTrachItems, { ...resource, subCategoryId: respiratorySubCategory.id }, this.facilityOrderId, this.patientId);
                _.extend(resource, { linkedTemplateId: response.id })
            }

            await this.actions.create(this.facilityOrderTemplateItems, resource, this.facilityOrderId, this.patientId);
            if(this.fetchPatientTemplates){
                await this.fetchPatientTemplates();
            }

            this.disabled = false;
            this.form.setFieldsDisabled(false);
            this.modalParams.close();

            this.rootStore.notificationStore.success('Facility order template successfully created.');
        }
        catch (err) {
            this.disabled = false;
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to create new facility order template.');
        }
    }

}

export default CreateFacilityOrderTemplateUSIntakeNewFlowModalStore;
